module.exports = __webpack_public_path__ + "img/total.6250f57d.svg";